export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-thumbnail-960-b6d02e68bae1b9d6f7b98805062d22ff.png";